<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUISettings } from 'dashboard/composables/useUISettings';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();
const isOpen = computed(
  () => uiSettings.value.is_contact_sidebar_open === true
);
const label = computed(() =>
  t(
    isOpen.value
      ? 'WORKSPACE_RESIZE.CONTACT_CLOSE'
      : 'WORKSPACE_RESIZE.CONTACT_OPEN'
  )
);
const toggle = () =>
  updateUISettings(
    isOpen.value
      ? { is_contact_sidebar_open: false }
      : { is_contact_sidebar_open: true, is_copilot_panel_open: false }
  );
</script>

<template>
  <div
    class="group relative z-[45] flex h-full w-2 shrink-0 items-center justify-center"
    data-testid="workspace-contact-toggle"
  >
    <button
      type="button"
      :aria-label="label"
      :aria-expanded="isOpen"
      :title="label"
      class="absolute left-1/2 top-1/2 z-10 flex size-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-xl border border-n-strong bg-n-solid-2 text-n-slate-11 shadow-sm transition-colors hover:border-n-brand hover:text-n-blue-11 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      @click="toggle"
    >
      <span
        class="size-4"
        :class="isOpen ? 'i-ph-caret-right' : 'i-ph-caret-left'"
        aria-hidden="true"
      />
    </button>
    <span
      class="pointer-events-none absolute right-full top-1/2 z-[60] w-48 -translate-y-1/2 rounded-xl border border-n-weak bg-n-solid-2 px-3 py-2 text-xs text-n-slate-12 opacity-0 shadow-lg transition-opacity group-hover:opacity-100 group-focus-within:opacity-100"
      >{{ label }}</span
    >
  </div>
</template>
